
import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';

const initialState = {
    currentMenuKey: "1"
};

export const CaiwuPageSlice = createSlice({
    name: 'caiwuPage',
    initialState,
    reducers: {
        setCurrentMenuKey: (state,action) => {
            console.log(999999999999999)
            console.log(state.currentMenuKey);
            state.currentMenuKey = action.payload;
        }
    },
});

export const selectCurrentMenuKey = (state) => state.caiwuPage.currentMenuKey;
export const {
    setCurrentMenuKey
} = CaiwuPageSlice.actions;

export default CaiwuPageSlice.reducer;
